const DepartmentList = [
    {
        id: 1,
        name: "IT/Technical",
        first_name: "Segun",
        last_name: "Taiwo"
    }
]

export default DepartmentList